export const CREATING_TRIPINFO = "CREATING_TRIPINFO";
export const UPDATING_TRIPINFO = "UPDATING_TRIPINFO";
export const TRIPINFO_CREATED = "TRIPINFO_CREATED";
export const TRIPINFO_UPDATED = "TRIPINFO_UPDATED";
export const ERROR_TRIPINFO_CREATE = "ERROR_TRIPINFO_CREATE";
export const ERROR_TRIPINFO_UPDATE = "ERROR_TRIPINFO_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
